<template>
    <div>
        <img class="w-100"  src="imgs/classroom.png" />
    </div>
</template>
<script>
export default {
    name: "Classroom"
}
</script>